import Routers from './Routes';
import 'antd/dist/antd.css';
function App() {
  return (
    <Routers />
  );
}

export default App;
